import type { FrontendWidget } from '../types';
import { HtmlSnippetComponent } from './HtmlSnippetComponent';
import type { HtmlSnippetConfig, HtmlSnippetResolved } from './types';

export const htmlSnippetWidget: FrontendWidget<
  HtmlSnippetConfig,
  HtmlSnippetResolved
> = {
  componentType: 'widgets.html-snippet',
  displayName: 'HTML Snippet',
  ComponentA: HtmlSnippetComponent,
  resolveSync: (config) => ({ html: config.html ?? '' }),
};
